import React, { useState } from 'react';
import nounarrows from '../../assets/images/noun_arrow_6402.png';
import cartfff from '../../assets/images/BF-Chart.png';


function Reporttitle() {
  

  return (
   <div className="reporttitle">
            <div className="reporttitle_l">
              <img src={cartfff} alt="arrows" />
              <h2>HQ DASHBOARD - Billing Report</h2>
            </div>
            <div className="reporttitle_r">
              <a href="/hqproductreport">
                Hq product analysis <img src={nounarrows} width="20" alt="arrow" />
              </a>
            </div>
          </div>
  );
}

export default Reporttitle;
